module.exports = __webpack_public_path__ + "static/media/eStore-hero-securityBag1.e0d9ca75.png";